var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDitoPayMultiplesPosFisicos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dito_Pay_Multiples_Pos_Fisicos",
    "data-name": "Dito Pay Multiples Pos Fisicos",
    transform: "translate(-899 -1405)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(899 1405)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User_Add-WF",
    "data-name": "User Add-WF",
    transform: "translate(928 1433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M48.72,38.868A2.029,2.029,0,0,1,50.751,40.9v5.82h5.822a2.031,2.031,0,0,1,0,4.063H50.751V56.6a2.031,2.031,0,0,1-4.062,0V50.781h-5.82a2.031,2.031,0,1,1,0-4.062h5.82V40.9A2.029,2.029,0,0,1,48.72,38.868Zm0-2.305A12.188,12.188,0,1,0,60.938,48.75,12.215,12.215,0,0,0,48.72,36.563ZM21.535,30.469A17.426,17.426,0,0,0,4.063,47.807a5.035,5.035,0,0,0,5.056,5.005H32.956l0-.006a16.244,16.244,0,0,1,8.714-18.7l.2-.089L41.3,33.6a17.494,17.494,0,0,0-10.026-3.135h-9.74ZM26.4,4.063a11.163,11.163,0,0,0-3.09,21.919,11.508,11.508,0,0,0,6.181,0A11.164,11.164,0,0,0,26.4,4.063ZM26.4,0A15.208,15.208,0,0,1,36.552,26.64l-.381.323.145.033A21.5,21.5,0,0,1,46,32.187l.482.467.169-.024A16.25,16.25,0,1,1,34.8,57.17l-.17-.295H9.118A9.1,9.1,0,0,1,0,47.807,21.462,21.462,0,0,1,16.159,27.081l.479-.116-.379-.322A15.208,15.208,0,0,1,26.4,0Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDitoPayMultiplesPosFisicos);
export default __webpack_public_path__ + "static/media/Dito Pay Multiples Pos Fisicos.1daa9680491be7595ca2112a4b796927.svg";
export { ForwardRef as ReactComponent };